function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconEmojiThink = function SvgIconEmojiThink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE17D"
    },
    cx: 256.001,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD164"
    },
    d: "M293.162,474.839c-141.385,0-256-114.615-256-256c0-61.227,21.521-117.411,57.376-161.463 C36.864,104.316,0.001,175.842,0.001,256c0,141.385,114.615,256,256,256c80.159,0,151.685-36.864,198.626-94.538 C410.574,453.317,354.39,474.839,293.162,474.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD164"
    },
    d: "M181.678,512L181.678,512c9.084,0,16.516-7.432,16.516-16.516l0,0 c0-9.084-7.432-16.516-16.516-16.516l0,0h8.258l0,0c9.084,0,16.516-7.432,16.516-16.516l0,0c0-9.084-7.432-16.516-16.516-16.516 l0,0h8.258c9.084,0,16.516-7.432,16.516-16.516l0,0c0-9.084-7.432-16.516-16.516-16.516h90.839c9.122,0,16.516-7.395,16.516-16.516 l0,0c0-9.122-7.395-16.516-16.516-16.516H140.388c-13.682,0-24.774-11.092-24.774-24.774V305.55 c0-9.122-7.395-16.516-16.516-16.516l0,0c-9.122,0-16.516,7.395-16.516,16.516v40.426c0,11.251-3.829,22.167-10.858,30.953 l-7.698,9.622c-9.371,11.714-14.477,26.269-14.477,41.27v34.632c0,27.365,22.184,49.548,49.548,49.548h82.581V512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC350"
    },
    d: "M198.195,495.484h-16.516H99.098c-18.214,0-33.032-14.818-33.032-33.032v-34.633 c0-11.208,3.856-22.201,10.857-30.952l7.699-9.622c9.335-11.669,14.476-26.326,14.476-41.27v-56.942 c-9.121,0-16.516,7.395-16.516,16.516v40.426c0,11.251-3.829,22.167-10.857,30.953l-7.698,9.622 c-9.371,11.714-14.477,26.269-14.477,41.27v34.633c0,27.365,22.183,49.548,49.548,49.548h82.581 C190.762,512,198.195,504.568,198.195,495.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC350"
    },
    d: "M305.549,396.387H189.936c-4.561,0-8.258,3.697-8.258,8.258c0,4.56,3.697,8.258,8.258,8.258h8.258 h90.839C298.155,412.903,305.549,405.509,305.549,396.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC350"
    },
    d: "M173.42,437.677c0,4.56,3.697,8.258,8.258,8.258h8.258h8.258c9.084,0,16.516-7.432,16.516-16.516 h-33.032C177.117,429.419,173.42,433.116,173.42,437.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC350"
    },
    d: "M165.162,470.71c0,4.56,3.697,8.258,8.258,8.258h8.258h8.258c9.084,0,16.516-7.432,16.516-16.516 H173.42C168.859,462.452,165.162,466.149,165.162,470.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA7346"
    },
    d: "M297.275,340.645c-1.556,0-3.137-0.355-4.629-1.105c-0.565-0.282-57.186-28.427-119.774-29.863 c-5.702-0.129-10.218-4.855-10.089-10.556c0.129-5.698,4.863-10.419,10.556-10.081c67.387,1.544,126.137,30.823,128.605,32.069 c5.089,2.565,7.129,8.77,4.565,13.859C304.695,338.569,301.057,340.645,297.275,340.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA7346"
    },
    d: "M189.928,134.194c-2.25,0-4.516-0.734-6.411-2.242c-1.556-1.222-37.065-28.472-79.806-7.105 c-5.081,2.552-11.306,0.476-13.847-4.617c-2.548-5.101-0.484-11.298,4.621-13.851c54.823-27.435,100.008,7.911,101.903,9.431 c4.452,3.56,5.169,10.056,1.613,14.508C195.961,132.867,192.961,134.194,189.928,134.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA7346"
    },
    d: "M305.541,150.714c-4.823,0-9.129-3.395-10.113-8.302c-1.121-5.589,2.508-11.028,8.097-12.145 l82.581-16.516c5.621-1.117,11.024,2.504,12.145,8.097c1.121,5.589-2.508,11.028-8.097,12.145l-82.581,16.516 C306.888,150.645,306.211,150.714,305.541,150.714z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D5046"
    },
    d: "M152.007,208.018L152.007,208.018c-11.316-1.395-19.359-11.7-17.964-23.016l2.021-16.392 c1.395-11.316,11.7-19.359,23.016-17.964l0,0c11.316,1.395,19.359,11.7,17.964,23.016l-2.021,16.392 C173.628,201.37,163.323,209.413,152.007,208.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C6846"
    },
    d: "M159.08,150.646c-1.404-0.173-2.791-0.198-4.149-0.092l-3.486,28.273 c-0.837,6.79,3.988,12.973,10.778,13.81s12.973-3.988,13.81-10.778l1.011-8.196C178.439,162.346,170.397,152.041,159.08,150.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D5046"
    },
    d: "M324.91,226.082L324.91,226.082c-11.316-1.395-19.359-11.7-17.964-23.016l2.021-16.392 c1.395-11.316,11.7-19.359,23.016-17.964l0,0c11.316,1.395,19.359,11.7,17.964,23.016l-2.021,16.392 C346.531,219.435,336.226,227.478,324.91,226.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C6846"
    },
    d: "M331.983,168.71c-1.404-0.173-2.791-0.198-4.149-0.092l-3.486,28.273 c-0.837,6.79,3.988,12.973,10.778,13.81c6.79,0.837,12.973-3.988,13.81-10.778l1.011-8.196 C351.342,180.41,343.3,170.106,331.983,168.71z"
  }));
};
export default SvgIconEmojiThink;